import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useBreakpoints } from 'common/hooks/use-breakpoints';
import { STATE_NAME_BY_SCREEN_NAME_MAP } from 'common/constants/state-name-by-screen-name-map';
export var RenderOnBreakpoints = function (_a) {
    var screen = _a.screen, or = _a.or, children = _a.children;
    var state = useBreakpoints(screen);
    return state[STATE_NAME_BY_SCREEN_NAME_MAP[screen]] ? _jsx(_Fragment, { children: children }) : _jsx(_Fragment, { children: or });
};
